import ReactApexChart from "react-apexcharts";
// import getChartColorsArray from "../../../components/Common/ChartsDynamicColor";

export default function GameChart(props) {
  const { chartData } = props;

  const series = [
    {
      name: "Participantes",
      data:
        chartData && chartData.length > 0
          ? chartData.map((e) => Number(e.total))
          : [],
    },
  ];
  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    colors: ["#04724c"],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories:
        chartData && chartData.length > 0
          ? chartData.map((e) => e.description)
          : [],
    },
    yaxis: {
      title: {
        text: "Quantidade de Participantes",
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val;
        },
      },
    },
  };

  // #04724c

  // tamanho da div dinamica
  const barWidth = 60; // largura por barra em px
  const chartWidth = options.xaxis.categories.length * barWidth;

  return (
    <div style={{ overflowX: "auto" }}>
      <div style={{ minWidth: chartWidth }}>
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={350}
        />
      </div>
    </div>
  );
}
